<template>
	<div>
		<h1 v-if="article?.title" class="text-ch-red text-2xl md:text-3xl font-medium md:leading-8 mb-0" v-html="article?.title"></h1>
		<h2 v-if="article?.subtitle" class="text-gray-700 text-lg md:text-2xl mt-0.5" v-html="article?.subtitle"></h2>

		<div v-if="issues !== null && issues?.children?.length > 0" class="grid grid-cols-1 gap-8 lg:grid-cols-3 sm:grid-cols-2 mt-6">
			<template v-for="child of issues?.children" :key="child?.slug">
				<a v-if="child?.meta?.external_link" target="_blank" :href="child?.meta?.external_link">
					<img class="transition-all rounded-none hover:scale-105 graphical-abstract !w-auto max-h-[340px]" :src="child?.meta?.img" alt="" />
					<p class="text-ch-red text-sm md:text-base mt-1">{{ child?.name }}</p>
          <p v-if="child?.meta?.subtitle" class="text-sm md:text-base font-light">{{ child?.meta?.subtitle }}</p>
				</a>
				<RouterLink v-else :to="`/archive/${issues?.slug}/${child?.slug}`">
          <img class="transition-all rounded-none hover:scale-105 graphical-abstract !w-auto max-h-[340px]" :src="child?.meta?.img" alt="" />
					<p class="text-ch-red text-sm md:text-base mt-1">{{ child?.name }}</p>
          <p v-if="child?.meta?.subtitle" class="text-sm md:text-base font-light">{{ child?.meta?.subtitle }}</p>
				</RouterLink>
			</template>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useApi } from '@/composables/useApi'

defineProps({
  article: {
    type: Object,
    required: true
  }
})

const route = useRoute()

const { api } = useApi()

const issues = ref(null)
const notFound = ref(false)

api({
  url: `/issue/${route.params?.pathMatch?.[1] ?? ''}`,
  callback: data => {
    issues.value = data
  },
  errorCallback: () => {
    notFound.value = true
  }
})
</script>
